<template>
  <div class="hzc-coke">
    <div class="content container">
      <div class="banner-left" @click="changeIndustrial">
        <p class="banner-title">{{ chainTitle }}</p>
        <div class="data1">{{ data1['druidParamName'] }} <em v-if="data1['price'] !== ''">:</em><span style="color: #2AD3DA">{{ data1['price'] }}</span></div>
        <div class="data2">{{ `${data2['druidParamName']}` }}<em v-if="data2['price'] !== ''">:</em> <span style="color: #2AD3DA">{{ data2['price'] }}</span>
        </div>
        <div class="data3">{{ `${data3['druidParamName']}` }}<em v-if="data3['price'] !== ''">:</em> <span style="color: #2AD3DA">{{ data3['price'] }}</span>
        </div>
        <div class="data4">{{ `${data4['druidParamName']}` }}<em v-if="data4['price'] !== ''">:</em> <span style="color: #2AD3DA">{{ data4['price'] }}</span>
        </div>
        <div class="data5">{{ `${data5['druidParamName']}` }}<em v-if="data5['price'] !== ''">:</em> <span style="color: #2AD3DA">{{ data5['price'] }}</span>
        </div>
        <div class="data6">{{ `${data6['druidParamName']}` }}<em v-if="data6['price'] !== ''">:</em> <span style="color: #2AD3DA">{{ data6['price'] }}</span>
        </div>
        <div class="differPrice1 redColor" v-if="chainPrice['differPrice1'] > 0">
          {{ '+' + chainPrice['differPrice1'] }}
        </div>
        <div class="differPrice1 greenColor" v-if="chainPrice['differPrice1'] < 0">{{ chainPrice['differPrice1'] }}
        </div>
        <div class="differPrice1" v-if="chainPrice['differPrice1'] === 0">—</div>
        <div class="differPrice2 redColor" v-if="chainPrice['differPrice2'] > 0">
          {{ '+' + chainPrice['differPrice2'] }}
        </div>
        <div class="differPrice2 greenColor" v-if="chainPrice['differPrice2'] < 0">{{ chainPrice['differPrice2'] }}
        </div>
        <div class="differPrice2" v-if="chainPrice['differPrice2'] === 0">—</div>
        <div class="differPrice3 redColor" v-if="chainPrice['differPrice3'] > 0">
          {{ '+' + chainPrice['differPrice3'] }}
        </div>
        <div class="differPrice3 greenColor" v-if="chainPrice['differPrice3'] < 0">{{ chainPrice['differPrice3'] }}
        </div>
        <div class="differPrice3" v-if="chainPrice['differPrice3'] === 0">—</div>
        <div class="differPrice4 redColor" v-if="chainPrice['differPrice4'] > 0">
          {{ '+' + chainPrice['differPrice4'] }}
        </div>
        <div class="differPrice4 greenColor" v-if="chainPrice['differPrice4'] < 0">{{ chainPrice['differPrice4'] }}
        </div>
        <div class="differPrice4" v-if="chainPrice['differPrice4'] === 0">—</div>
        <div class="differPrice5 redColor" v-if="chainPrice['differPrice5'] > 0">
          {{ '+' + chainPrice['differPrice5'] }}
        </div>
        <div class="differPrice5 greenColor" v-if="chainPrice['differPrice5'] < 0">{{ chainPrice['differPrice5'] }}
        </div>
        <div class="differPrice5" v-if="chainPrice['differPrice5'] === 0">—</div>
      </div>
      <div class="banner-right">
        <div class="title">
          <div class="title-write" @mouseover="changeIndustrialFlag(112)" @click="toTwoPage('/needle/twoPage/industry', '112')"
               :class="{'title-write-red' : industryFlag===112}">行业要闻
          </div>
          <div class="title-write" @mouseover="changeIndustrialFlag(113)" @click="toTwoPage('/needle/twoPage/industry', '113')"
               :class="{'title-write-red' : industryFlag===113}">国际动态
          </div>
          <span class="title-more fr" @click="toTwoPage('/needle/twoPage/industry')">更多 ></span>
        </div>
        <div class="banner-right-content" v-if="industryFlag === 112">
          <ul>
            <li v-for="(item, index) in industryOneList" :key="index">
              <p v-if="item.newsType===1" @click="goDetail('/needle/industry', item.id, 112)">{{ item.titleName }}</p>
              <p v-else @click="openUrl(item)">{{ item.titleName }}</p>
              <span class="fr">{{ item.showTime }}</span>
            </li>
          </ul>
        </div>
        <div class="banner-right-content" v-if="industryFlag === 113">
          <ul>
            <li v-for="(item, index) in industryTwoList" :key="index">
              <p v-if="item.newsType===1" @click="goDetail('/needle/industry', item.id, 113)">{{ item.titleName }}</p>
              <p v-else @click="openUrl(item)">{{ item.titleName }}</p>
              <span class="fr">{{ item.showTime }}</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="classification">
      <ul class="clearfix">
        <li>
          <ClassificationHeader :name="'价格'" :flag="false" :unit="false"
                                :params="{title:'价格',typeList:['市场价格', '出厂价格']}"
                                :url="'/needle/twoPage/price'"></ClassificationHeader>
          <span class="classification-tabs-two" @mouseover="priceFlag = 'issue_needle_market_price'"
                style="width:186px;"
                @click="toTwoPage('/needle/twoPage/price', 'issue_needle_market_price')"
                :class="{'stockFlag':priceFlag === 'issue_needle_market_price'}">市场价格</span>
          <span class="classification-tabs-two" @mouseover="priceFlag = 'issue_needle_factory_price'"
                style="width:186px;"
                @click="toTwoPage('/needle/twoPage/price', 'issue_needle_factory_price')"
                :class="{'stockFlag':priceFlag === 'issue_needle_factory_price'}">出厂价格</span>
          <div class="classification-content" style="margin-top: 4px"
               v-if="priceFlag === 'issue_needle_market_price'">
            <div class="classification-content-div" style="height: 31px;line-height: 31px;"
                 v-for="(item, index) in priceOneList" :key="index"
                 @click="goDetail('/needle/price', item.completeOriginalDate, 'issue_needle_market_price')">
              <i></i>
              <p>{{ item.date + '针状焦市场价格' }}</p>
              <span class="fr">{{ item.originalDate }}</span>
            </div>
          </div>
          <div class="classification-content" style="margin-top: 4px"
               v-if="priceFlag === 'issue_needle_factory_price'">
            <div class="classification-content-div" style="height: 31px;line-height: 31px;"
                 v-for="(item, index) in priceTwoList" :key="index"
                 @click="goDetail('/needle/price', item.completeOriginalDate, 'issue_needle_factory_price')">
              <i></i>
              <p>{{ item.date + '针状焦出厂价格' }}</p>
              <span class="fr">{{ item.originalDate }}</span>
            </div>
          </div>
        </li>
        <li>
          <ClassificationHeader :name="'产量'" :flag="false" :unit="false" :neibu="true"
                                :params="{title:'产量',typeList:['按企业', '按月度']}"
                                :url="'/needle/twoPage/yield'"></ClassificationHeader>
          <span class="classification-tabs-two" @mouseover="yieldFlag = 'manual_entry_needle_reception_rate'"
                style="width:186px;"
                @click="toTwoPage('/needle/twoPage/yield', 'manual_entry_needle_reception_rate')"
                :class="{'stockFlag':yieldFlag === 'manual_entry_needle_reception_rate'}">按企业</span>
          <span class="classification-tabs-two" @mouseover="yieldFlag = '75'"
                style="width:186px;"
                @click="toTwoPage('/needle/twoPage/yield', '75')"
                :class="{'stockFlag':yieldFlag === '75'}">按月度</span>
          <div class="classification-content" style="margin-top: 4px"
               v-if="yieldFlag === 'manual_entry_needle_reception_rate'">
            <div class="classification-content-div" style="height: 31px;line-height: 31px;"
                 v-for="(item, index) in yieldOneList" :key="index"
                 @click="goDetail('/needle/yield', item.completeOriginalDate, 'manual_entry_needle_reception_rate')">
              <i></i>
              <p>{{ item.date + '针状焦产量按企业' }}</p>
              <span class="fr">{{ item.originalDate }}</span>
            </div>
          </div>
          <div class="classification-content" style="margin-top: 4px"
               v-if="yieldFlag === '75'">
            <div class="classification-content-div" style="height: 31px;line-height: 31px;"
                 v-for="(item, index) in yieldTwoList" :key="index"
                 @click="goDetail('/needle/yieldXin', item.id, '75')">
              <i></i>
              <p>{{ item.titleName }}</p>
              <span class="fr">{{ item.showTime }}</span>
            </div>
          </div>
        </li>
        <li>
          <div class="head" style="border-bottom: none">
            <em></em>
            <p>研究报告</p>
            <span class="fr" @click="toTwoPage('/needle/twoPage/report')"> >></span>
            <img src="../../assets/home/neibu.png" style="width: 70px;margin-left: 10px;" alt="">
            <div class="report-tabs">
              <div class="tabs-i" :class="{'tabs-i-hover':reportFlag === 1}"
                   @click="reportToPage('/needle/twoPage/report', 1)" @mouseover="changeReportFlag(1)">日报
              </div>
              <div class="tabs-i" :class="{'tabs-i-hover':reportFlag === 2}"
                   @click="reportToPage('/needle/twoPage/report', 2)" @mouseover="changeReportFlag(2)">周报
              </div>
              <div class="tabs-i" :class="{'tabs-i-hover':reportFlag === 3}"
                   @click="reportToPage('/needle/twoPage/report', 3)" @mouseover="changeReportFlag(3)">月报
              </div>
            </div>
          </div>
          <div class="classification-content research">
            <img style="width: 360px" src="../../assets/home/yanjiubaogao.png" alt="">
            <div v-if="reportFlag === 1">
              <div class="classification-content-div" v-for="(item, index) in reportList" :key="index">
                <i></i>
                <p style="width: 200px;" @click="downloadReport(item)">{{ item.fileTitle }}</p>
                <span class="fr">{{ item.showTime }}</span>
              </div>
            </div>
            <div v-if="reportFlag === 2">
              <div class="classification-content-div" v-for="(item, index) in reportListWeek" :key="index">
                <i></i>
                <p style="width: 200px;" @click="downloadReport(item)">{{ item.fileTitle }}</p>
                <span class="fr">{{ item.showTime }}</span>
              </div>
            </div>
            <div v-if="reportFlag === 3">
              <div class="classification-content-div" v-for="(item, index) in reportListMonth" :key="index">
                <i></i>
                <p style="width: 200px;" @click="downloadReport(item)">{{ item.fileTitle }}</p>
                <span class="fr">{{ item.showTime }}</span>
              </div>
            </div>
          </div>
        </li>
        <li>
          <img src="../../assets/home/kucun.png" alt="">
          <span style="font-size: 24px;font-weight: 500;color: #fff;position: absolute;top: 20px;left: 20px;">库存</span>
          <span @click="toTwoPage('/needle/twoPage/stock')"
                style="right: 10px;position: absolute;top: 24px;color: #fff;cursor: pointer;"> >></span>
          <img src="../../assets/home/neibu.png" style="position: absolute;left: 83px;width: 70px;top: 24px;" alt="">
          <div class="classification-content" style="margin-top: 4px">
            <div class="classification-content-div" v-for="(item, index) in stockList" :key="index"
                 @click="goDetail('/needle/stock', item.completeOriginalDate,'manual_entry_needle_reception_stock')">
              <i></i>
              <p>{{ item.date + '针状焦样本点企业库存' }}</p>
              <span class="fr">{{ item.originalDate }}</span>
            </div>
          </div>
        </li>
        <li>
          <img src="../../assets/home/kaigonglv.png" alt="">
          <span style="font-size: 24px;font-weight: 500;color: #fff;position: absolute;top: 20px;left: 20px;">开工率</span>
          <span @click="toTwoPage('/needle/twoPage/rate')"
                style="right: 10px;position: absolute;top: 24px;color: #fff;cursor: pointer;"> >></span>
          <img src="../../assets/home/neibu.png" style="position: absolute;left: 100px;width: 70px;top: 24px;" alt="">
          <div class="classification-content" style="margin-top: 4px">
            <div class="classification-content-div" v-for="(item, index) in rateList" :key="index"
                 @click="goDetail('/needle/rate', item.completeOriginalDate,'manual_entry_needle_reception_rate')">
              <i></i>
              <p>{{ item.date + '针状焦样本点企业开工率' }}</p>
              <span class="fr">{{ item.originalDate }}</span>
            </div>
          </div>
        </li>
        <li>
          <ClassificationHeader :name="'进出口量'" :flag="false" :unit="false"
                                :params="{title:'进出口量',typeList:['油系', '煤系']}"
                                :url="'/needle/twoPage/exit'"></ClassificationHeader>
          <span class="classification-tabs-two" @mouseover="exitFlag = '76'"
                style="width:186px;"
                @click="toTwoPage('/needle/twoPage/exit', '76')"
                :class="{'stockFlag':exitFlag === '76'}">油系</span>
          <span class="classification-tabs-two" @mouseover="exitFlag = '77'"
                style="width:186px;"
                @click="toTwoPage('/needle/twoPage/exit', '77')"
                :class="{'stockFlag':exitFlag === '77'}">煤系</span>
          <div class="classification-content" style="margin-top: 4px"
               v-if="exitFlag === '76'">
            <div class="classification-content-div" style="height: 31px;line-height: 31px;"
                 v-for="(item, index) in exitOneList" :key="index"
                 @click="goDetail('/needle/exit', item.id, '76')">
              <i></i>
              <p>{{ item.titleName }}</p>
              <span class="fr">{{ item.showTime }}</span>
            </div>
          </div>
          <div class="classification-content" style="margin-top: 4px"
               v-if="exitFlag === '77'">
            <div class="classification-content-div" style="height: 31px;line-height: 31px;"
                 v-for="(item, index) in exitTwoList" :key="index"
                 @click="goDetail('/needle/exit', item.id, '77')">
              <i></i>
              <p>{{ item.titleName }}</p>
              <span class="fr">{{ item.showTime }}</span>
            </div>
          </div>
        </li>
        <li>
          <img src="../../assets/home/kaigonglv.png" style="margin-bottom: -6px;" alt="">
          <span
              style="font-size: 24px;font-weight: 500;color: #fff;position: absolute;top: 20px;left: 20px;">下游开工率</span>
          <span @click="toTwoPage('/needle/twoPage/downRate')"
                style="right: 10px;position: absolute;top: 24px;color: #fff;cursor: pointer;"> >></span>
          <span class="classification-tabs-two" @mouseover="downRateFlag = 'manual_entry_needle_graphite_rate'"
                style="width:186px;"
                @click="toTwoPage('/needle/twoPage/downRate', 'manual_entry_needle_graphite_rate')"
                :class="{'stockFlag':downRateFlag === 'manual_entry_needle_graphite_rate'}">石墨电极</span>
          <span class="classification-tabs-two" @mouseover="downRateFlag = 'manual_entry_needle_negative_rate'"
                style="width:186px;"
                @click="toTwoPage('/needle/twoPage/downRate', 'manual_entry_needle_negative_rate')"
                :class="{'stockFlag':downRateFlag === 'manual_entry_needle_negative_rate'}">负极材料</span>
          <div class="classification-content" style="margin-top: 4px"
               v-if="downRateFlag === 'manual_entry_needle_graphite_rate'">
            <div class="classification-content-div" style="height: 31px;line-height: 31px;"
                 v-for="(item, index) in downRateOneList" :key="index"
                 @click="goDetail('/needle/downRate', item.completeOriginalDate, 'manual_entry_needle_graphite_rate')">
              <i></i>
              <p>{{ item.date + '石墨电极开工率' }}</p>
              <span class="fr">{{ item.originalDate }}</span>
            </div>
          </div>
          <div class="classification-content" style="margin-top: 4px"
               v-if="downRateFlag === 'manual_entry_needle_negative_rate'">
            <div class="classification-content-div" style="height: 31px;line-height: 31px;"
                 v-for="(item, index) in downRateTwoList" :key="index"
                 @click="goDetail('/needle/downRate', item.completeOriginalDate, 'manual_entry_needle_negative_rate')">
              <i></i>
              <p>{{ item.date + '负极材料开工率' }}</p>
              <span class="fr">{{ item.originalDate }}</span>
            </div>
          </div>
        </li>
        <li>
          <ClassificationHeader :name="'下游产品价格'" :flag="true" :unit="false"
                                :url="'/needle/twoPage/downPrice'"></ClassificationHeader>
          <div class="classification-content" style="margin-top: 4px">
            <div class="classification-content-div" v-for="(item, index) in downPriceList" :key="index"
                 @click="goDetail('/needle/downPrice', item.completeOriginalDate,'issue_needle_down_price')">
              <i></i>
              <p>{{ item.date + '针状焦下游产品价格' }}</p>
              <span class="fr">{{ item.originalDate }}</span>
            </div>
          </div>
        </li>
        <li>
          <ClassificationHeader :name="'技术及标准'" :flag="true" :unit="false" :url="'/needle/twoPage/standard'" :neibu="true"
                                :params="{title:'技术及标准'}"></ClassificationHeader>
          <div class="classification-content">
            <div class="classification-content-div" v-for="(item, index) in standardList" :key="index">
              <i></i>
              <p style="width: 200px;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;"
                 @click="downloadStandard(item)">{{ item.fileTitle }}</p>
              <span class="fr" style="color: #777777;font-size: 12px;">{{ item.showTime }}</span>
            </div>
          </div>
        </li>
      </ul>
    </div>
    <el-dialog custom-class="previewDialog" :destroy-on-close="true" :close-on-click-modal="false" width="1194px"
               :visible.sync="industrialFlag">
      <MaterialIndustrial @closeIndustrialCh="closeIndustrial" v-if="industrialFlag"></MaterialIndustrial>
    </el-dialog>
  </div>
</template>

<script>
import {
  industryNoAuthList,
  zetarPriceNoAuthList,
  zetarReportNoAuthList,
  chainList,
} from '@/api/zetar'
import {
  enterNoAuthList, industryDetail,
  reportDetail,
  standardDetail
} from '@/api/needle'
import ClassificationHeader from '@/components/common/ClassificationHeader'
import Expect from '@/components/common/expect'
import MaterialIndustrial from '@/components/bigChart/materialIndustrial'

export default {
  components: {
    ClassificationHeader,
    MaterialIndustrial,
    Expect,
  },
  data() {
    return {
      industrialFlag: false,
      // 行业动态
      industryFlag: 112,
      industryOneList: [],
      industryTwoList: [],
      // 研究报告
      reportList: [],
      reportListWeek: [],
      reportListMonth: [],
      reportFlag: 2,
      // 价格指数
      priceFlag: 'issue_needle_market_price',
      priceOneList: [],
      priceTwpList: [],
      // 产量
      yieldFlag: 'manual_entry_needle_reception_rate',
      yieldOneList: [],
      yieldTwoList: [],
      // 下游产品价格
      downPriceList: [],
      // 进出口量
      exitFlag: '76',
      exitOneList: [],
      exitTwoList: [],
      // 行业标准
      standardList: [],
      // 库存
      stockList: [],
      // 开工率
      rateList: [],
      // 下游开工率
      downRateFlag: 'manual_entry_needle_graphite_rate',
      downRateOneList: [],
      downRateTwoList: [],
      // 产业链
      chainTitle: '',
      data1: {},
      data2: {},
      data3: {},
      data4: {},
      data5: {},
      data6: {},
      chainPrice: {},
    }
  },
  created() {
    this.getHomeList()
  },
  methods: {
    /**
     * 获取首页信息
     */
    getHomeList() {
      // 产业链
      chainList({dictDataType: 'issue_needle_small_chain'}).then(res => {
        this.chainTitle = res.data['data1']['date'];
        this.data1 = res.data['data1'];
        this.data2 = res.data['data2'];
        this.data3 = res.data['data3'];
        this.data4 = res.data['data4'];
        this.data5 = res.data['data5'];
        this.data6 = res.data['data6'];
        this.chainPrice = res.data['price'];
      })
      // 行业动态
      industryNoAuthList({pageNum: 1, pageSize: 8, sourceType: 112}).then(res => {
        this.industryOneList = res.rows;
      })
      industryNoAuthList({pageNum: 1, pageSize: 8, sourceType: 113}).then(res => {
        this.industryTwoList = res.rows;
      })
      // 价格指数
      zetarPriceNoAuthList({pageNum: 1, pageSize: 7, dictDataType: 'issue_needle_market_price'}).then(res => {
        this.priceOneList = res.rows;
      })
      zetarPriceNoAuthList({pageNum: 1, pageSize: 7, dictDataType: 'issue_needle_factory_price'}).then(res => {
        this.priceTwoList = res.rows;
      })
      // 产量
      enterNoAuthList({pageNum: 1, pageSize: 7, dictDataType: 'manual_entry_needle_reception_rate'}).then(res => {
        this.yieldOneList = res.rows;
      })
      industryNoAuthList({pageNum: 1, pageSize: 7, sourceType: 75}).then(res => {
        this.yieldTwoList = res.rows;
      })
      // 下游产品价格
      zetarPriceNoAuthList({pageNum: 1, pageSize: 8, dictDataType: 'issue_needle_down_price'}).then(res => {
        this.downPriceList = res.rows;
      })
      // 研究报告
      zetarReportNoAuthList({pageNum: 1, pageSize: 6, sourceType: 6, fileType: 1}).then(res => {
        this.reportList = res.rows;
      })
      zetarReportNoAuthList({pageNum: 1, pageSize: 6, sourceType: 6, fileType: 2}).then(res => {
        this.reportListWeek = res.rows;
      })
      zetarReportNoAuthList({pageNum: 1, pageSize: 6, sourceType: 6, fileType: 3}).then(res => {
        this.reportListMonth = res.rows;
      })
      // 库存
      enterNoAuthList({pageNum: 1, pageSize: 6, dictDataType: 'manual_entry_needle_reception_stock'}).then(res => {
        this.stockList = res.rows;
      })
      // 开工率
      enterNoAuthList({pageNum: 1, pageSize: 6, dictDataType: 'manual_entry_needle_reception_rate'}).then(res => {
        this.rateList = res.rows;
      })
      // 下游开工率
      enterNoAuthList({pageNum: 1, pageSize: 6, dictDataType: 'manual_entry_needle_graphite_rate'}).then(res => {
        this.downRateOneList = res.rows;
      })
      enterNoAuthList({pageNum: 1, pageSize: 6, dictDataType: 'manual_entry_needle_negative_rate'}).then(res => {
        this.downRateTwoList = res.rows;
      })
      // 进出口
      industryNoAuthList({pageNum: 1, pageSize: 7, sourceType: 76}).then(res => {
        this.exitOneList = res.rows;
      })
      industryNoAuthList({pageNum: 1, pageSize: 7, sourceType: 77}).then(res => {
        this.exitTwoList = res.rows;
      })
      // 技术及标准
      zetarReportNoAuthList({pageNum: 1, pageSize: 8, sourceType: 6, fileType: 4}).then(res => {
        this.standardList = res.rows;
      })
    },
    /**
     * 前往行业报告二级
     */
    reportToPage(url, flag) {
      this.$router.push({path: url, query: {flag}})
    },
    /**
     * 打开关闭模态
     */
    changeIndustrial() {
      this.industrialFlag = true;
    },
    closeIndustrial() {
      this.industrialFlag = false;
    },
    /**
     *  行业动态外链
     */
    openUrl(item) {
      industryDetail(item['id']).then(() => {
        window.openUrl(item.newsContent)
      })
    },
    /**
     * 切换tabs
     */
    changeIndustrialFlag(flag) {
      this.industryFlag = flag;
    },
    /**
     * 预览文件
     */
    downloadReport(row) {
      reportDetail(row['id'] + '/1').then((res) => {
        this.$setMenuInfoPath(['针状焦', '研究报告', '正文'], row['id']);
      })
    },
    downloadStandard(row) {
      standardDetail(row['id'] + '/1').then((res) => {
        this.$setMenuInfoPath(['针状焦', '技术及标准', '正文'], row['id']);
      })
    },
    /**
     * 切换研究报告tabs
     */
    changeReportFlag(flag) {
      this.reportFlag = flag;
    },
    /**
     * 跳转二级页
     * @param url
     */
    toTwoPage(url, flag, num) {
      this.$router.push({path: `${url}`, query: {flag, num}});
    },
    /**
     * 跳转详情页
     */
    goDetail(url, id, flag, other) {
      this.$router.push({path: `${url}`, query: {id, flag, other}})
    },
  },
}
</script>

<style scoped lang="less">

.report-tabs {
  position: absolute;
  top: 3px;
  right: 11px;

  .tabs-i {
    display: inline-block;
    font-style: normal;
    margin-right: 10px;
    cursor: pointer;
    font-size: 14px;
  }

  .tabs-i:hover {
    color: #D3131A;
    border-bottom: 2px solid #D3131A;
  }
}

.tabs-i-hover {
  color: #D3131A;
  border-bottom: 2px solid #D3131A;
}

.content {
  height: 355px;
  width: 1200px;
  margin: 0 auto;

  .banner-left {
    width: 650px;
    height: 360px;
    display: inline-block;
    background: url("../../assets/images/zhenzhuangjiaobanner.png");
    background-size: 100% 100%;
    color: #fff;
    position: relative;
    cursor: pointer;

    img {
      width: 650px;
      height: 360px;
    }

    .banner-title {
      position: absolute;
      color: #B2F0E4;
      top: 34px;
      left: 268px;
      font-size: 12px;
    }

    .data1 {
      font-size: 10px;
      position: absolute;
      top: 177px;
      left: 19px;
      width: 96px;
      height: 50px;
    }

    .data2 {
      font-size: 10px;
      position: absolute;
      top: 177px;
      left: 180px;
      width: 95px;
      height: 50px;
    }

    .data3 {
      font-size: 10px;
      position: absolute;
      top: 149px;
      left: 343px;
      width: 95px;
      height: 50px;
    }

    .data4 {
      font-size: 10px;
      position: absolute;
      top: 202px;
      left: 343px;
      width: 95px;
      height: 50px;
    }

    .data5 {
      font-size: 10px;
      position: absolute;
      top: 125px;
      left: 502px;
      width: 106px;
      height: 50px;
    }

    .data6 {
      font-size: 10px;
      position: absolute;
      top: 232px;
      left: 505px;
      width: 101px;
      height: 50px;
    }

    .differPrice1 {
      position: absolute;
      top: 160px;
      left: 127px;
      width: 25px;
      height: 25px;
      text-align: center;
    }

    .differPrice2 {
      position: absolute;
      top: 163px;
      left: 290px;
      width: 25px;
      height: 25px;
      text-align: center;
    }

    .differPrice3 {
      position: absolute;
      top: 190px;
      left: 290px;
      width: 25px;
      height: 25px;
      text-align: center;
    }

    .differPrice4 {
      position: absolute;
      top: 117px;
      left: 446px;
      width: 25px;
      height: 25px;
      text-align: center;
    }

    .differPrice5 {
      position: absolute;
      top: 242px;
      left: 446px;
      width: 25px;
      height: 25px;
      text-align: center;
    }
  }

  .banner-right {
    width: 510px;
    height: 360px;
    margin-left: 40px;
    display: inline-block;
    vertical-align: top;

    .title {
      width: 100%;
      border-bottom: 1px solid #ccc;
      height: 36px;
      line-height: 36px;

      .title-write {
        display: inline-block;
        width: 96px;
        height: 36px;
        border-radius: 4px 4px 0px 0px;
        text-align: center;
        line-height: 36px;
        color: #333;
        cursor:pointer;
      }

      .title-write-red {
        color: #fff;
        background: #D3131A;
      }

      .title-more {
        cursor: pointer;
        color: #666666;
        font-size: 12px;
      }
    }

    .banner-right-content {
      ul {
        li {
          margin-top: 11px;

          p {
            display: inline-block;
            width: fit-content;
            max-width: 450px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            height: 20px;
            line-height: 20px;
            cursor: pointer;
            // 透明border
            border-style: solid;
            border-width: 1px;
            border-color: transparent;
          }

          p:hover {
            color: #D3131A;
            //border-bottom: 1px solid #D3131A;
            text-decoration: underline;
          }

          span {
            display: inline-block;
            height: 20px;
            font-size: 12px;
            color: #777777;
            line-height: 20px;
          }
        }
      }
    }
  }
}

.classification {
  width: 1200px;
  margin: 0 auto;
  padding-top: 39px;

  ul {
    li {
      float: left;
      width: 372px;
      margin-right: 42px;
      height: 300px;
      margin-bottom: 43px;
      position: relative;

      img {
        width: 372px;
      }

      .head {
        color: #222222;
        height: 35px;
        font-size: 18px;
        line-height: 30px;
        position: relative;
        border-bottom: 2px solid #ccc;

        .red-title {
          width: 168px;
          height: 36px;
          background: #D3131A;
          border-radius: 4px 4px 0px 0px;
          color: #fff;
          text-align: center;
          line-height: 36px;
        }

        i {
          width: 60px;
          height: 2px;
          background: #CCCCCC;
          display: inline-block;
          position: absolute;
          bottom: 0;
        }

        em {
          width: 4px;
          height: 18px;
          background: #D3131A;
          font-style: normal;
          display: inline-block;
          margin-right: 9px;
          vertical-align: middle;
        }

        img {
          vertical-align: middle;
          margin-right: 9px;

        }

        p {
          font-size: 18px;
          display: inline-block;
          vertical-align: middle;
        }

        span {
          font-size: 12px;
          cursor: pointer;
          height: 20px;
          border-bottom: 1px solid #fff;
        }

        span:hover {
          border-bottom: 1px solid #222;
        }
      }

      .classification-tabs-two {
        width: 93px;
        height: 34px;
        line-height: 34px;
        display: inline-block;
        background: #F2F2F2;
        color: #222;
        text-align: center;
        cursor: pointer;
      }

      .priceFlag {
        border-top: 2px solid #D3131A;
        background-color: #fff;
      }

      .classification-tabs-two:hover {
        background: #D3131A;
        color: #fff;
      }

      .classification-tabs-three {
        width: 93px;
        height: 36px;
        line-height: 34px;
        display: inline-block;
        background: #F2F2F2;
        color: #222;
        text-align: center;
        cursor: pointer;
      }

      .stockFlag {
        background: #D3131A;
        color: #fff;
      }

      .classification-tabs-three:hover {
        background-color: #D3131A;
        color: #fff;
      }

      .classification-content {
        .classification-content-div {
          height: 33px;
          line-height: 33px;

          i {
            width: 4px;
            height: 4px;
            background: #9B857B;
            display: inline-block;
            margin-right: 5px;
            border-radius: 50%;
          }

          p {
            width: 250px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            display: inline-block;
            vertical-align: middle;
            cursor: pointer;
            // 透明border
            border-style: solid;
            border-width: 1px;
            border-color: transparent;
          }

          p:hover {

            color: #D3131A;
            text-decoration: underline;
            //border-bottom: 1px solid #D3131A;
          }

          span {
            color: #777777;
            font-size: 12px;
          }

        }

        .price {
          height: 33px;
          line-height: 33px;
          padding: 0 10px;

          img {
            margin-right: 5px;
            width: 8px;
          }
        }

        .price:nth-child(2n+0) {
          background: #F2F2F2;
        }
      }

      .research {
        width: 360px;
        height: 262px;
        border-radius: 0px 0px 4px 4px;
        border: 6px solid #DDDDDD;

        .classification-content-div {
          border-bottom: 1px dashed rgba(211, 19, 26, 0.25);
          height: 35px;
          line-height: 35px;
          margin-top: -1px;

          i {
            margin-left: 5px;
          }

          span {
            margin-right: 5px;
          }
        }

        .classification-content-div:last-child {
          border-bottom: none;
        }
      }
    }

    li:nth-child(3n+0) {
      margin-right: 0;
    }
  }
}

.exitClass {
  .classification-content-div {
    margin-top: 8px;
  }

  p {
    max-width: 200px;
    display: inline-block;
    cursor: pointer;
    // 透明border
    border-style: solid;
    border-width: 1px;
    border-color: transparent;
  }

  p:hover {
    color: #D3131A;
    //border-bottom: 1px solid #D3131A;
    text-decoration: underline;
  }
}

.bulletinWai {
  overflow: auto;
  height: 211px;
  border-bottom: 1px solid #ccc;
}

.bulletin {
  padding: 12px;

  .top {
    img {
      width: 20px;
      border-radius: 50%;
      vertical-align: middle;
    }

    span {
      margin-left: 6px;
      color: #777;
    }

    em {
      color: #777;
      float: right;
      font-style: normal;
    }
  }

  .text {
    padding-left: 28px;
  }
}

.redColor {
  color: #FF6969;
}

.greenColor {
  color: #43E97B;
}
</style>
